import {useCallback, useEffect, useMemo, useState} from "react";
import SetupApi from "../api/functions/Setup";
import {SetupInterface} from "../../interfaces/private/SetupInterface";
import {config} from "../../config";
import {getSyncEngineVersion} from "../helpers/syncEngine";
import {getEffectiveSyncModules} from "../helpers/setupCompleteness";
import {SyncModuleKey} from "../../features/public/SetupV2/helpers/onboardingModules";

export function useSetupSummary() {
    const [setup, setSetup] = useState<SetupInterface>({});
    const [loading, setLoading] = useState(true);
    const isV2 = getSyncEngineVersion() === "v2";

    const reload = useCallback(async () => {
        setLoading(true);
        try {
            const response: any = await SetupApi.detail();
            if (response?.status === config.STATUS_CODE.OK) {
                setSetup(response?.data?.data || {});
            }
        } catch {
            // ignore
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        reload();
    }, [reload]);

    const enabledModules = useMemo((): SyncModuleKey[] => {
        if (!isV2) {
            return ["invoice", "payment", "payout", "subscription"];
        }
        return getEffectiveSyncModules(setup);
    }, [isV2, setup]);

    return {setup, loading, isV2, enabledModules, reload};
}
